var TEMPLATE_URL = require('./premium.trial.tile.html');

angular.module('ikeweb.user').directive('premiumTrialTile', [

    function() {
        return {
            replace: true,
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            scope: {
                currentCard: '=',
                subscription: '=',
                trialDaysRemaining: '=',
                openPurchasePremiumModal: '&',
                openUpdateCard: '&',
                cancelSubscriptionTrial: '='
            },
            link: function($scope, $element) {

                var ccView = $element.find('.Subscription-creditCardView');
                var cancelDialog = $element.find('.Subscription-cancelConfirmDialog');

                function closeCreditCardView() {
                    ccView.addClass('Subscription-creditCardView--closed')
                        .removeClass('Subscription-creditCardView--open');
                }

                function closeCancelDialog() {
                    cancelDialog.addClass('Subscription-cancelConfirmDialog--closed')
                        .removeClass('Subscription-cancelConfirmDialog--open');
                }

                $scope.toggleCreditCardView = function() {
                    closeCancelDialog();
                    ccView.toggleClass('Subscription-creditCardView--closed')
                        .toggleClass('Subscription-creditCardView--open');
                };

                $scope.openCancelDialog = function() {
                    closeCreditCardView();
                    cancelDialog.addClass('Subscription-cancelConfirmDialog--open')
                        .removeClass('Subscription-cancelConfirmDialog--closed');
                };

                $scope.closeCancelDialog = closeCancelDialog;
            },
            controller: 'PremiumTrialTileController'
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/billing/premium.trial.tile.directive.js
// module id = 498
// module chunks = 0